import Joi from 'joi'
import errorsResolver from '../../../../../validation/schemeUtils'
import moment from "moment";

const calculationLayoutSchema = (minDate, maxDate, isAnnuity, isHybrid)=> {
    let minDateFormat = moment(minDate)
    let maxDateFormat = moment(maxDate).add(1, 'days')
    const amountField = {
        amount: Joi.number()
            .min(1)
            .required()
            .empty('')
            .error(errorsResolver({
                required: 'Сумма обязательное поле',
                numberBase: 'Сумма должна быть числом',
                numberMin: 'Сумма должна быть больше 0',
                numberUnsafe: 'Некорректное число'
            }))
    };

    const booleanFields = {
        waiverOfRedemption: Joi.bool(),
        isNonCash: Joi.bool()
    };

    const dateField = {
        endDate: Joi.date()
            .iso()
            .less(maxDateFormat)
            .greater(minDateFormat)
            .error(errorsResolver({
                dateFormat: 'Некорректная дата',
                dateLess: 'Дата договора выходит за пределы купона',
                dateGreater: 'Дата договора выходит за пределы купона'
            }))
    };

    const annuityFields = {
        months: Joi.object({
            value: Joi.number(),
            label: Joi.string()      
        })
            .invalid(null)
            .required()
            .error(errorsResolver({
                invalid: `Срок выдачи обязательное поле`,
                required: `Срок выдачи обязательное поле`,
            })),
    };

    const hybridFields = {
        firstPaymentDate: Joi.date()
            .iso()
            .required()
            .error(errorsResolver({
                required: 'Дата первого платежа обязательное поле',
                dateFormat: 'Некорректная дата'
            })),
        ...annuityFields
    };

    let contractTypeFields = dateField;
    if (isHybrid) {
        contractTypeFields = hybridFields;
    } else if (isAnnuity) {
        contractTypeFields = annuityFields;
    }

    return Joi.object({
        calculation: Joi.object({
            ...amountField,
            ...booleanFields,
            ...contractTypeFields
        })
    });
}


export default calculationLayoutSchema
